//middleware
import { Route } from "react-router-dom";

//views
import { ROUTES } from "../utils/routes";
import { News } from "../views/Logged/News/News";
import { ManageNews } from "../views/Logged/News/ManageNews/ManageNews";
import { ManageResourceFolder } from "../views/Logged/Resources/ManageResources/ManageResourceFolder";
import { Resources } from "../views/Logged/Resources/Resources";
import { ManageResource } from "../views/Logged/Resources/ManageResources/ManageResource";


const Communication = () => {
  // prettier-ignore
  return (
    <>

      <Route exact path={ROUTES.News.all} component={News} />
      <Route
        exact
        path={[ROUTES.News.create, ROUTES.News.update]}
        component={ManageNews}
      />
         <Route exact path={ROUTES.Resource.all} component={Resources} />
            <Route
              exact
              path={[ROUTES.Resource.create, ROUTES.Resource.update]}
              component={ManageResource}
            />
            <Route
              exact
              path={[ROUTES.RESOURCEFOLDERS.create, ROUTES.RESOURCEFOLDERS.update]}
              component={ManageResourceFolder}
            />
    </>
  );
};

export default Communication;
